import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { LocalDateTime } from '@js-joda/core';
import { IsOptional } from 'class-validator';
import { TimeframeWithLocalTimes } from '../../api/shared';
import { RecordingSegment } from '../../read';
export class StreamRecordingSummary {
    /**
     * @param id Identifies the recording.
     * @param courtSystemId Identifies the court system the recording belongs to
     * @param locationId Identifies where the recording took place
     * @param departmentId Identifies the department for this recording
     * @param videoStreamCount The number of video streams, as provided by the streaming client
     * @param start The local time that the streaming client provided when initiating the streaming session
     * @param segments Streams which make up the recording
     * @param audioChannelCount The number of audio channels
     * @param sealedSegments An array of non-overlapping timeframes that have been 'sealed'
     * @param hasMultiChannel Whether the recording has a multichannel playlist
     * @param onTheRecordTimeframes The times frames during which this recording was on the record
     * @param availableTimeframes The precise local times that the user can access in this recording
     * @param hasStt Whether the recording has speech to text
     * @param tags Features or attributes of this recording, eg 'stt', 'multichannel'
     */
    constructor(id, courtSystemId, locationId, departmentId, videoStreamCount, start, segments, audioChannelCount, sealedSegments = [], hasMultiChannel = false, onTheRecordTimeframes, availableTimeframes = [], hasStt, tags) {
        this.id = id;
        this.courtSystemId = courtSystemId;
        this.locationId = locationId;
        this.departmentId = departmentId;
        this.videoStreamCount = videoStreamCount;
        this.audioChannelCount = audioChannelCount;
        this.sealedSegments = sealedSegments;
        this.hasMultiChannel = hasMultiChannel;
        this.onTheRecordTimeframes = onTheRecordTimeframes;
        this.hasStt = hasStt;
        this.start = start;
        this.segments = segments;
        this.availableTimeframes = availableTimeframes;
        this.tags = tags;
    }
}
__decorate([
    Serialize(),
    __metadata("design:type", LocalDateTime)
], StreamRecordingSummary.prototype, "start", void 0);
__decorate([
    Type(() => RecordingSegment),
    __metadata("design:type", Array)
], StreamRecordingSummary.prototype, "segments", void 0);
__decorate([
    Type(() => TimeframeWithLocalTimes),
    __metadata("design:type", Array)
], StreamRecordingSummary.prototype, "availableTimeframes", void 0);
__decorate([
    Serialize(),
    IsOptional(),
    __metadata("design:type", Set)
], StreamRecordingSummary.prototype, "tags", void 0);
